import { Routes } from "@angular/router";
import { HomeComponent } from "@pages/home/home.component";
import { LoginFailedComponent } from "@pages/login/login-failed/login-failed.component";
import { LoginComponent } from "@pages/login/login.component";
import { NotAuthorizedComponent } from "@pages/login/not-authorized/not-authorized.component";
import { NotFoundComponent } from "@pages/not-found/not-found.component";
import { CanActivateGuard } from "./can-activate.guard";
import { MainTemplateComponent } from "./templates/main-template/component/main-template.component";

export const routes: Routes = [
    {
        path: "WorkingPaperReportPreview",
        loadComponent: () =>
            import(
                "./pages/papel-trabalho/working-paper-report-preview/working-paper-report-preview.component"
            ).then((m) => m.WorkingPaperReportPreviewComponent)
    },
    {
        path: "SendDocuments",
        loadComponent: () =>
            import(
                "./pages/jornada.auditoria/jornada.auditoria.document.upload/jornada.auditoria.document.upload.component"
            ).then((m) => m.DocumentUploadComponent)
    },
    {
        path: "ReportPreview",
        loadComponent: () =>
            import(
                "./pages/jornada.auditoria/jornada.auditoria.report.control.preview/jornada.auditoria.report.control.preview.component"
            ).then((m) => m.ReportControlPreviewComponent)
    },
    {
        path: "ResponseLetter",
        loadComponent: () =>
            import(
                "./pages/jornada.auditoria/jornada.auditoria.response.letter/jornada.auditoria.response.letter.component"
            ).then((m) => m.ResponseLetterComponent)
    },
    {
        path: "ResponseLetter/item/:id",
        loadComponent: () =>
            import(
                "./pages/jornada.auditoria/jornada.auditoria.response.letter/response-letter-detail/response-letter-detail.component"
            ).then((m) => m.ResponseLetterDetailComponent)
    },
    {
        path: "",
        component: MainTemplateComponent,
        // Apenas CanActivateGuard: ele já faz a verificação completa de autenticação
        // (contas MSAL + ssoSilent + acquireTokenSilent + validação do usuário no backend),
        // retornando /login quando não autenticado. O MsalGuard foi removido por ser redundante
        // e por concorrer na ativação da rota, causando um flash da tela de login em aba nova.
        canActivate: [CanActivateGuard],
        canActivateChild: [CanActivateGuard],
        children: [
            {
                path: "",
                redirectTo: "Home",
                pathMatch: "full"
            },
            {
                path: "Home",
                component: HomeComponent
            },
            {
                path: "AuditReportType",
                loadChildren: () =>
                    import("./pages/audit-report-type/audit-report-type.route").then((m) => m.auditReportTypeRoutes)
            },
            {
                path: "SystemType",
                loadChildren: () => import("./pages/SystemType/SystemType.routes").then((m) => m.SystemTypeRoutes)
            },
            {
                path: "ItemType",
                loadChildren: () => import("./pages/TipoItem/TipoItem.routes").then((m) => m.TipoItemRoutes)
            },
            {
                path: "Area",
                loadChildren: () => import("./pages/Area/Area.routes").then((m) => m.AreaRoutes)
            },
            {
                path: "RoleType",
                loadChildren: () => import("./pages/RoleType/RoleType.routes").then((m) => m.RoleTypeRoutes)
            },
            {
                path: "WorkingPaperType",
                loadChildren: () =>
                    import("./pages/WorkingPaperType/WorkingPaperType.routes").then((m) => m.WorkingPaperTypeRoutes)
            },
            {
                path: "EntityType",
                loadChildren: () => import("./pages/EntityType/EntityType.routes").then((m) => m.EntityTypeRoutes)
            },
            {
                path: "ExternalQueries",
                loadChildren: () =>
                    import("./pages/externalQueries/externalQueries.routes").then((m) => m.externalQueriesRoutes)
            },
            {
                path: "DocumentScholarshipType",
                loadChildren: () => import("./pages/docs-free/docs-free.routes").then((m) => m.docsFreeRoutes)
            },
            {
                path: "DocsFree",
                loadChildren: () => import("./pages/docs-free/docs-free.routes").then((m) => m.docsFreeRoutes)
            },
            {
                path: "DocumentServerStatusType",
                loadChildren: () =>
                    import("./pages/documentServerStatusType/documentServerStatusType.routes").then(
                        (m) => m.documentServerStatusType
                    )
            },
            {
                path: "Dashboard",
                loadComponent: () => import("./pages/dashboard/dashboard.component").then((m) => m.DashboardComponent)
            },
            {
                path: "Entities",
                loadChildren: () => import("./pages/entidades/entidades.routes").then((m) => m.EntidadesRoutes)
            },
            {
                path: "AuditJourneyScope",
                loadChildren: () =>
                    import("./pages/plano.acao.geral/plano.acao.geral.routes").then((m) => m.planoAcaoGeralRoutes)
            },
            {
                path: "AuditJourney",
                loadChildren: () =>
                    import("./pages/jornada.auditoria/jornada.auditoria.routes").then((m) => m.jornadaAuditoriaRoutes)
            },
            {
                path: "ConvertReportControl",
                loadChildren: () =>
                    import("./pages/administracao/administracao.routes").then((m) => m.administracaoRoutes)
            },
            {
                path: "AuditManagement",
                loadChildren: () =>
                    import("./pages/plano.acao.auditor/plano.acao.auditor.routes").then((m) => m.planoAcaoAuditorRoutes)
            },
            {
                path: "AuditScope",
                loadChildren: () =>
                    import("./pages/plano.auditoria/plano.auditoria.routes").then((m) => m.PlanoAuditoriaRoutes)
            },
            {
                path: "Fpe",
                loadChildren: () => import("./pages/fpe/fpe.routes").then((m) => m.fpeRoutes)
            },
            {
                path: "State",
                loadChildren: () => import("./pages/uf/uf.routes").then((m) => m.ufRoutes)
            },
            {
                path: "CashierVoucherType",
                loadChildren: () =>
                    import("./pages/cashier-voucher-type/cashier-voucher-type.routes").then(
                        (m) => m.CashierVoucherTypeRoutes
                    )
            },
            {
                path: "Country",
                loadChildren: () => import("./pages/country/country.routes").then((m) => m.CountryRoutes)
            },
            {
                path: "Object",
                loadChildren: () => import("./pages/objetos/objetos.routes").then((m) => m.objetosRoutes)
            },
            {
                path: "AuditRegion",
                loadChildren: () =>
                    import("./pages/regiao-auditoria/regiao-auditoria-routes").then((m) => m.RegiaoAuditoriaRoutes)
            },
            {
                path: "AnalysisType",
                loadChildren: () =>
                    import("./pages/analysis-type/analysis-type.routes").then((m) => m.AnalysisTypeRoutes)
            },
            {
                path: "Profile",
                loadChildren: () => import("./pages/auditor/auditor.routes").then((m) => m.AuditorRoutes)
            },
            {
                path: "Observation",
                loadChildren: () => import("./pages/observacao/obeservacao.routes").then((m) => m.ObservacaoRoutes)
            },
            {
                path: "MenuUserProfile",
                loadChildren: () => import("./pages/menu-perfil-usuario/menu.routes").then((m) => m.MenuRoutes)
            },
            {
                path: "WorkingPaper",
                loadChildren: () =>
                    import("./pages/papel-trabalho/papel-trabalho-routes").then((m) => m.PapeisTrabalhoRoutes)
            },
            {
                path: "CurrencyTypes",
                loadChildren: () => import("./pages/tipo-moeda/tipo-moeda.routes").then((m) => m.tipoMoedaRoutes)
            },
            {
                path: "PeriodicityTypes",
                loadChildren: () =>
                    import("./pages/periodicity-types/periodicity-types.routes").then((m) => m.periodicityTypesRoutes)
            },
            {
                path: "SituationType",
                loadChildren: () =>
                    import("./pages/situation-type/situation-type.routes").then((m) => m.situationTypeRoutes)
            },
            {
                path: "ScoreTypes",
                loadChildren: () => import("./pages/score-type/score-type.route").then((m) => m.scoreTypeRoutes)
            },
            {
                path: "ObservationType",
                loadChildren: () =>
                    import("./pages/observation-type/observation-type.routes").then((m) => m.observationTypeRoutes)
            },
            {
                path: "ProfileType",
                loadChildren: () => import("./pages/profile-type/profile-type.routes").then((m) => m.profileTypeRoutes)
            },
            {
                path: "CashierReceiptType",
                loadChildren: () =>
                    import("./pages/cashier-receipt-type/cashier-receipt-type.route").then(
                        (m) => m.CashierReceiptTypeRoutes
                    )
            },
            {
                path: "ChartAccountsTypes",
                loadChildren: () =>
                    import("./pages/chart-accounts-types/chart-accounts-types.routes").then(
                        (m) => m.ChartAccountsTypesRoutes
                    )
            },
            {
                path: "JourneyScopeVerificationType",
                loadChildren: () =>
                    import("./pages/journey-scope-verification-types/journey-scope-verification-type.route").then(
                        (m) => m.JourneyScopeVerificationTypeRoutes
                    )
            },
            {
                path: "RemunerationScaleType",
                loadChildren: () =>
                    import("./pages/remuneration-scale-type/remuneration-scale-type.routes").then(
                        (m) => m.remunerationScaleTypeRoutes
                    )
            },
            {
                path: "AuditScopeTypes",
                loadChildren: () =>
                    import("./pages/audit-scope-types/audit-scope-types.route").then((m) => m.AuditScopeTypesRoutes)
            },
            {
                path: "Survey",
                loadChildren: () =>
                    import("./pages/nps/nps.routes").then((m) => m.npsRoutes)
            }
        ]
    },
    { path: "code", component: LoginComponent },
    { path: "login", component: LoginComponent },
    { path: "login-failed", component: LoginFailedComponent },
    { path: "not-authorized", component: NotAuthorizedComponent },
    { path: "not-found", component: NotFoundComponent },
    { path: "**", component: NotFoundComponent }
];
